import { render, staticRenderFns } from "./BooksSearch.vue?vue&type=template&id=43ab85c8&scoped=true&"
import script from "./BooksSearch.vue?vue&type=script&lang=js&"
export * from "./BooksSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab85c8",
  null
  
)

export default component.exports